
try {
  var RUSTIG_BASEPATH = document.querySelector("meta[name='rustigbase']").getAttribute("content");
  if (RUSTIG_BASEPATH.substr(-1) !== '/') {
    RUSTIG_BASEPATH += '/';
  }
  var CKEDITOR_BASEPATH = RUSTIG_BASEPATH + "ckeditor/";

} catch (error) {
  console.warn("You must include a meta tag with the rustig base path in your markup.\nOmitting this value may cause certain modules to work incorrectly\nExample: <meta name='rustigbase' content='http://localhost:7777/content/vendor/rustig'>");
}

